(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["feature-tabs"] && !Shopify.designMode) return;
  try {
    
  (() => {
    document.querySelectorAll('.kpt-feature-tabs').forEach((root) => {
      if (root.dataset.initialized === 'true') return;
      root.dataset.initialized = 'true';
      const items = [...root.querySelectorAll('[data-feature-item]')];
      const panels = [...root.querySelectorAll('[data-feature-panel]')];
      const setActive = (index) => {
        items.forEach((item, itemIndex) => {
          const active = itemIndex === index;
          item.classList.toggle('is-active', active);
          const button = item.querySelector('.kpt-feature-tabs__button');
          const info = item.querySelector('.kpt-feature-tabs__info');
          button?.setAttribute('aria-expanded', active ? 'true' : 'false');
          if (info) info.hidden = !active;
        });
        panels.forEach((panel, panelIndex) => panel.classList.toggle('is-active', panelIndex === index));
      };
      items.forEach((item, index) => item.querySelector('.kpt-feature-tabs__button')?.addEventListener('click', () => setActive(index)));
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
